export default {
      id: "icon-sheep-usage",
      viewBox: "0 0 450.734 115.595",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-sheep",
      toString: function () {
        return this.url;
      }
    }